export function fireImagePing(url: string): void {
    const img = new Image();
    img.src = url;
    img.height = 0;
    img.width = 0;
    img.style.display = 'none';
    img.onload = function () {
        img.parentNode.removeChild(img);
    };

    document.body.insertBefore(img, document.body.firstChild);
}
